import React from "react";
import styled from "styled-components";

export default styled.textarea`
    width: 100%;
    resize: none;
    color: #717198;  
    margin-bottom: 47px;
    height: 90px;
    font-size: 16px;
    padding: 4px 11px;
    border: .5px solid lightgrey;
`;